import Vue from "vue";

const prodServer = "https://api.consigmais.com.br";
const devServer = "https://test.api.consigmais.com.br/server";

const imageUri = function(file, transformation) {
  if (!file) return "";

  if (file && file.match("static")) {
    return file;
  } else if (file && file.match("assets")) {
    return file.replace("assets", "static");
  }

  switch (transformation) {
    case "avatar":
      transformation = "h_75,c_fill,ar_1:1,g_face,q_auto:best";
      break;
    case "logo":
      transformation = "c_fit,h_150,q_auto:best";
      break;
    case "sqLogo":
      transformation =
        "ar_1:1,b_rgb:262c35,bo_5px_solid_rgb:262c35,c_lpad,h_100,r_max,w_100";
      break;
    case "smLogo":
      transformation = "h_50,c_fit,ar_1:1,q_auto:best";
      break;
    case "photo":
      transformation = "h_200,c_thumb,q_auto:best";
      break;
    case "photoBigger":
      transformation = "c_thumb,q_auto:best";
      break;
    default:
      transformation = "h_75,c_fill,ar_1:1,g_face,q_auto:best";
  }

  let tfile = `${transformation}/${file}`.replace("//", "/");
  return `https://res.cloudinary.com/consigmais/image/upload/${tfile}`;
};

console.log(">>> ENV: " + process.env.NODE_ENV);

const config = {
  serverHost:
    process.env.NODE_ENV == "production"
      ? prodServer
      : devServer,
  appName: "Consigmais",
  chatButton: false,
  favorites: false,
  toolbarSelector: false,
  mediaStorage: {
    imgUrl: "https://res.cloudinary.com/consigmais/image/upload",
    uploadUrl: "https://api.cloudinary.com/v1_1/consigmais/upload",
    presets: {
      customer: { id: "osefhec6-custfile", folder: "customer" },
      avatar: { id: "jyrlhwiq-avatar", folder: "avatar" },
    },
  },
  imageUri,

  // reqFrom: ''
};

Vue.prototype.$config = config;

export default config;



// WEBPACK FOOTER //
// ./src/config.js